export const TERMS_LINK = '/blog/2026/06/01/june-car-prize-draw';
